let state = {
    Cards : [
        {
            title: "Klipsch",
            subtitle: "Cinema 400",
            text_1: `Саундбар Cinema 400 использует патентованные технологии компании Klipsch и легок в установке.`,
            text_2: `Cinema 400 — это простое решение, которое значительно дополнит ваш телевизор, позволит расслышать каждую ноту музыки и насладиться каждой сценой из фильмов.`,
            src: "/img/card1.png",
            class: "left",
            href: "https://www.pult.ru/product/saundbar-klipsch-cinema-400-sound-bar"
        },
        {   
            title: "Klipsch",
            subtitle: "Cinema 600",
            text_1: `Саундбар Klipsch Cinema 600 изготовлен в корпусе из MDF, что обеспечило его хорошие демпфирующие и антирезонансные характеристики. Внешний облик модели за счет практически сплошной защитной сетки, закрывающей его боковые панели, получился привлекательным и лаконичным. Небольшая высота саундбара позволяет разметить его непосредственно перед телевизором, не перекрывая его экран или ИК-приемник.`,
            text_2: `Саундбар оформлен в черном цвете, однако у него сменные боковые накладки, что позволяет заменить их на панели с другой отделкой.`,
            src: "/img/card2.png",
            class: "right",
            href: "https://www.pult.ru/product/saundbar-klipsch-cinema-600-sound-bar"
        },
        {
            title: "Klipsch",
            subtitle: "Cinema 800",
            text_1: `Саундбар Cinema 800 мощностью 800 Вт с технологией Dolby Atmos позволит вам познакомиться с плодами нескольких десятилетий исследований и разработок в сфере профессиональной кинематографической акустики, не выходя из дома.`,
            text_2: `Это означает, что звуковое сопровождение фильмов и телепередач будет обладать такой же мощью, динамикой и детализацией, как в настоящем кинотеатре. Технология Dolby Atmos обеспечивает формирование звука над головами зрителей для создания более реального эффекта объемности.`,
            src: "/img/card3.png",
            class: "left",
            href: "https://www.pult.ru/product/saundbar-klipsch-cinema-800-sound-bar"
        },
        {
            title: "Klipsch",
            subtitle: "Cinema 1200",
            text_1: `Звуковая панель Cinema 1200 Dolby Atmos мощностью 1200 Вт со встроенными высотными и отдельно стоящими тыловыми АС приносит к вам в дом итог нескольких десятилетий исследований и разработок в сфере профессиональной кинематографической акустики — с тем же мощным, динамичным и детальным звучанием, что и в настоящем кинотеатре.`,
            text_2: `Технология Dolby Atmos обеспечивает живой звук, исходящий со всех сторон, в том числе сверху, что позволяет добиваться поразительной четкости, детальности и глубины.`,
            src: "/img/card4.png",
            class: "right",
            href: "https://www.pult.ru/product/saundbar-klipsch-cinema-1200-sound-bar"
        },
        {
            title: "Klipsch",
            subtitle: "SURROUND 3",
            text_1: `Беспроводные колонки Klipsch Surround 3 предназначены длят использования в качестве тыловых с совместимыми саундбарами Klipsch.`,
            text_2: `Добавьте эти колонки к саундбару и создайте собственный домашний кинотеатр в формате 5.1`,
            src: "/img/card5.png",
            class: "left",
            href: "https://www.pult.ru/product/besprovodnaya-akustika-klipsch-surround-3"
        }
    ]
}
export default state;